class BackToTop extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.lastKnownY = 0
    this.isTicking = false

    this.updateVisibility()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.updateVisibility = this.updateVisibility.bind(this)

    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, `click`, this.handleTrigger)
    })

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  handleTrigger () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY
    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) {
      requestAnimationFrame(this.updateVisibility)
    }

    this.isTicking = true
  }

  updateVisibility () {
    this.isTicking = false
    const threshold = window.innerHeight * 0.5
    const shouldShow = this.lastKnownY >= threshold
    this.setAttribute('aria-hidden', !shouldShow)
  }
}

if (!customElements.get('back-to-top')) {
  customElements.define('back-to-top', BackToTop)
}
